export default {
	name: 'FieldTables',
	options: {
		tablename: 'v_fields_table',
		schema: 'fields'
	}
};